import script from "./PrePourPrototype.vue?vue&type=script&setup=true&lang=js"
export * from "./PrePourPrototype.vue?vue&type=script&setup=true&lang=js"

import "./PrePourPrototype.vue?vue&type=style&index=0&id=3ebd7963&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ebd7963"]])

export default __exports__